<template>
  <div class="content projectAdd">
    <el-form ref="form" :model="form" label-width="0">
      <el-card class="box-card">
        <div style="display:flex;width:100%;justify-content: space-between;">
          <div style="width:30%;display:flex;align-items: center;">
            <p class="required" style="width:120px;">项目名称：</p>
            <el-input v-model="form.name" style="flex:1;"></el-input>
          </div>
          <div style="width:30%;display:flex;align-items: center;">
            <p style="width:120px;">项目类型：</p>
            <el-select v-model="form.projectType" class="box-select" placeholder="请选择">
              <el-option v-for="item in types" :key="item.id" :label="item.name" :value="item.id"></el-option>
            </el-select>
          </div>
          <div style="width:30%;display:flex;align-items: center;">
            <p style="width:120px;">项目状态：</p>
            <el-select v-model="form.projectStatus" class="box-select" placeholder="请选择">
              <el-option v-for="item in status" :key="item.id" :label="item.name" :value="item.id"></el-option>
            </el-select>
          </div>
          <el-button type="primary" style="float: right;" @click="saveProject">保存</el-button>
        </div>
      </el-card>
      <el-card class="box-card">
        <p style="margin:0 0 5px 0;text-align: left;">项目概况：</p>
        <el-input type="textarea" placeholder="请输入项目概况" v-model="form.description"></el-input>
      </el-card>
      <el-card class="box-card">
        <div style="display:flex;width:100%;">
          <div style="width:40%;display:flex;align-items: center;">
            <p style="width:150px;">是否上传到市平台：</p>
            <el-select v-model="form.detuoFlag" class="box-select" placeholder="请选择">
              <el-option
                v-for="item in isUpload"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
          </div>
          <div style="width:30%;display:flex;align-items: center;">
            <p style="width:110px;">登录id</p>
            <el-input v-model="form.loginId" style="flex:1;"></el-input>
          </div>
        </div>
      </el-card>
      <el-card class="box-card">
        <div class="pro-box1">
          <div class="item">
            <p style="width:160px;">建设规模：</p>
            <el-input v-model="form.areas" style="flex:1;"></el-input>
            <p style="width:100px;">平方</p>
          </div>
          <div class="item">
            <p style="width:160px;">施工许可证：</p>
            <el-input v-model="form.permit" style="flex:1;"></el-input>
            <p style="width:100px;"></p>
          </div>
          <div class="item">
            <p style="width:160px;">合同价格：</p>
            <el-input v-model="form.price" style="flex:1;"></el-input>
            <p style="width:100px;">万元</p>
          </div>
        </div>
      </el-card>
      <el-card class="box-card">
        <div class="pro-box1">
          <div class="item">
            <p style="width:160px;">合同开工日期：</p>
            <el-date-picker
              type="date"
              placeholder="选择日期"
              v-model="form.startDate"
              @change="dataFun"
              style="felx:1;"
              value-format="yyyy-MM-dd"
            ></el-date-picker>
            <p style="width:100px;"></p>
          </div>
          <div class="item">
            <p style="width:160px;">合同竣工日期：</p>
            <el-date-picker
              type="date"
              placeholder="选择日期"
              v-model="form.endDate"
              @change="dataFun"
              style="felx:1;"
              value-format="yyyy-MM-dd"
            ></el-date-picker>
            <p style="width:100px;"></p>
          </div>
          <div class="item">
            <p style="width:160px;">合同工期：</p>
            <el-input v-model="form.allDay" readonly style="flex:1;"></el-input>
            <p style="width:100px;">天</p>
          </div>
        </div>
      </el-card>
      <el-card class="box-card">
        <div class="pro-box1">
          <div class="item">
            <p style="width:110px;">银行网点：</p>
            <el-input v-model="form.bankAddress" style="flex:1;"></el-input>
            <p style="width:100px;"></p>
          </div>
          <div class="item">
            <p style="width:110px;">监管账户：</p>
            <el-input v-model="form.accountCapital" style="flex:1;"></el-input>
            <p style="width:100px;"></p>
          </div>
          <div class="item">
            <p style="width:110px;">开户支行：</p>
            <el-input v-model="form.bankBranch" style="flex:1;"></el-input>
            <p style="width:100px;"></p>
          </div>
          <div class="item">
            <p style="width:130px;">项目专户名称：</p>
            <el-input v-model="form.accountName" style="flex:1;"></el-input>
          </div>
        </div>
        
      </el-card>
      <el-card class="box-card pro-box2">
        <p style="margin:0 0 5px 0;text-align: left;">项目效果图：</p>
        <div class="box-img">
          <el-upload
            class="avatar-uploader"
            v-bind:action="uploadUrl"
            :headers="uploadHead"
            :data="{type:205}"
            :show-file-list="false"
            :on-success="handleSuccess1"
          >
            <img v-if="image1" :src="image1" class="avatar" />
            <i v-else class="el-icon-plus avatar-uploader-icon"></i>
          </el-upload>
          <el-upload
            class="avatar-uploader"
            v-bind:action="uploadUrl"
            :headers="uploadHead"
            :data="{type:205}"
            :show-file-list="false"
            :on-success="handleSuccess2"
          >
            <img v-if="image2" :src="image2" class="avatar" />
            <i v-else class="el-icon-plus avatar-uploader-icon"></i>
          </el-upload>
          <el-upload
            class="avatar-uploader"
            v-bind:action="uploadUrl"
            :headers="uploadHead"
            :data="{type:205}"
            :show-file-list="false"
            :on-success="handleSuccess3"
          >
            <img v-if="image3" :src="image3" class="avatar" />
            <i v-else class="el-icon-plus avatar-uploader-icon"></i>
          </el-upload>
        </div>
      </el-card>
      <el-card class="box-card" v-if="prot=='1'">
        <div class="pro-box3">
          <div class="item-con">
            <div class="item">
              <p style="width:160px;">建设单位：</p>
              <el-select v-model="form.entId" class="box-select" filterable placeholder="请选择">
                <el-option
                  v-for="item in projects"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                ></el-option>
              </el-select>
              <p style="width:100px;"></p>
            </div>
            <div class="item">
              <p style="width:160px;">联系人：</p>
              <!-- <el-input v-model="form.entManager" style="flex:1;"></el-input> -->
              <el-select
                v-model="form.entManager"
                class="box-select"
                filterable
                placeholder="请选择"
                style="flex:1;"
              >
                <el-option
                  v-for="item in persons"
                  :key="item.personId"
                  :label="item.name+'（'+item.idcard+'）'"
                  :value="item.personId"
                ></el-option>
              </el-select>
              <p style="width:100px;"></p>
            </div>
            <div class="item">
              <p style="width:160px;">联系人电话：</p>
              <el-input v-model="form.entTel" style="flex:1;"></el-input>
              <p style="width:100px;"></p>
            </div>
          </div>
          <!-- <div class="item-con">
                    <div class="item">
                        <p style="width:160px;">施工单位：</p>
                        <el-select v-model="form.constructionId" filterable class="box-select" placeholder="请选择">
                            <el-option
                                v-for="item in projects"
                                :key="item.id"
                                :label="item.name"
                                :value="item.id">
                            </el-option>
                        </el-select>
                        <p style="width:100px;"></p>
                    </div>
                    <div class="item">
                        <p style="width:160px;">项目经理：</p>
                        <el-select v-model="form.constructionManager" class="box-select" filterable placeholder="请选择" style="flex:1;">
                            <el-option
                                v-for="item in persons"
                                :key="item.personId"
                                :label="item.name+'（'+item.idcard+'）'"
                                :value="item.personId">
                            </el-option>
                        </el-select>
                        <p style="width:100px;"></p>
                    </div>
                    <div class="item">
                        <p style="width:160px;">联系人电话：</p>
                        <el-input v-model="form.constructionTel" style="flex:1;"></el-input>
                        <p style="width:100px;"></p>
                    </div>
          </div>-->
        </div>
      </el-card>
      <el-card class="box-card">
        <div class="pro-box4">
          <div class="item-con">
            <div class="item">
              <p style="width:160px;">项目地址：</p>
              <el-cascader
                :props="{value:'id',label:'name'}"
                :options="areas"
                v-model="selectedOptions"
                change-on-select="true"
              ></el-cascader>
            </div>
            <div class="item">
              <p style="width:160px;">详细位置：</p>
              <el-input v-model="form.address" style="flex:1;"></el-input>
            </div>
            <div
              v-if="form.id!=''&&form.id!='0'"
              class="item"
              style="margin-left:20px;color:#409EFF;"
            >
              <!-- <router-link :to="'/proPoint/'+form.id">地图定位</router-link> -->
              <a style="cursor: pointer;" @click="goMapAddr">地图定位</a>
            </div>
          </div>
          <!-- <div class="item-con" style="height: 600px;width:100%;">
                    <baidu-map :center="center" :zoom="zoom" @ready="handler" style="height:100%;width:100%;" @click="getClickInfo" :scroll-wheel-zoom='true'></baidu-map>
          </div>-->
        </div>
      </el-card>
    </el-form>
  </div>
</template>
<script>
import myHttp from '../../../untils/port'
import base from '../../../untils/base'
import util from '../../../untils/util.js'
export default {
  data() {
    return {
      imageUrl: '',
      form: {
        id: '',
        projectType: '1',
        projectStatus: '2',
        description: '',
        areas: '',
        permit: '',
        price: '',
        startDate: '',
        endDate: '',
        allDay: 0,
        photoPath: '',
        entId: '',
        entManager: '',
        entTel: '',
        constructionId: '',
        constructionManager: '',
        constructionTel: '',
        supervisionId: '',
        supervisionManager: '',
        supervisionTel: '',
        designId: '',
        designManager: '',
        designTel: '',
        surveyId: '',
        surveyManager: '',
        surveyTel: '',
        areaId: '',
        address: '',
        gpsPoint: '',
        detuoFlag: '', //是否上传到市平台
        loginId: '',
        bankAddress:'',
        accountCapital:'',
        bankBranch:'',
        accountName:''
      },
      selectedOptions: [],
      areas: [],
      projects: [],
      uploadUrl: base.url + '/upload/uploadPhoto', //上传地址
      uploadHead: {
        //上传接口header参数
        accessToken: this.$store.state.token
      },
      image1: '',
      image2: '',
      image3: '',
      image: {
        img1: '',
        img2: '',
        img3: ''
      },
      center: { lng: 117.283334, lat: 31.866339 },
      zoom: 13,
      map: {},
      geoc: {},
      persons: [], //项目人员
      types: [
        { id: '1', name: '房建' },
        { id: '2', name: '市政' },
        { id: '3', name: '水利' },
        { id: '4', name: '机电' }
      ],
      status: [
        { id: '1', name: '拟建' },
        { id: '2', name: '在建' },
        { id: '3', name: '竣工' },
        { id: '4', name: '停建' }
      ],
      prot: '',
      isUpload: [
        { label: '否', value: '0' },
        {
          label: '是',
          value: '1'
        }
      ] //是否上传到市平台
    }
  },
  mounted() {
    this.getProjects()
    this.getArea()
    var params = this.$route.params
    this.prot = util.session.get('roleId')
    if (params.id == '0') {
      this.form.id = ''
    } else {
      this.form.id = params.id
      this.getPerson()
      this.getData()
    }
  },
  methods: {
    //获取项目人员
    getPerson() {
      var that = this
      myHttp
        .getProPerson({
          projectId: this.form.id
        })
        .then(
          function(resp) {
            if (resp.data.code == '200') {
              var list = resp.data.data.pageInfo || []
              that.persons = list
            } else {
              that.$message.error(resp.data.msg)
            }
          },
          function() {}
        )
    },
    //获取区域
    getArea() {
      var that = this
      myHttp.getAreaList().then(
        function(resp) {
          if (resp.data.code == '200') {
            var list = resp.data.data.areaList
            var tree = util.common.listToTree('id', 'parentId', list)
            that.areas = tree
          } else {
            that.$message.error(resp.data.msg)
          }
        },
        function() {}
      )
    },
    //获取项目
    getProjects() {
      var that = this
      myHttp.getAllEnt().then(
        function(resp) {
          if (resp.data.code == '200') {
            var list = resp.data.data.entList || []
            that.projects = list
          } else {
            that.$message.error(resp.data.msg)
          }
        },
        function() {}
      )
    },
    //上传图片1
    handleSuccess1(res, file) {
      if (res.code == '200') {
        this.image1 = URL.createObjectURL(file.raw)
        this.image.img1 = res.data.saveUrls
      } else {
        this.$message.error(res.msg)
      }
    },
    //上传图片2
    handleSuccess2(res, file) {
      if (res.code == '200') {
        this.image2 = URL.createObjectURL(file.raw)
        this.image.img2 = res.data.saveUrls
      } else {
        this.$message.error(res.msg)
      }
    },
    //上传图片3
    handleSuccess3(res, file) {
      if (res.code == '200') {
        this.image3 = URL.createObjectURL(file.raw)
        this.image.img3 = res.data.saveUrls
      } else {
        this.$message.error(res.msg)
      }
    },
    //获取数据
    getData() {
      var that = this
      myHttp
        .getProjectById({
          id: this.form.id
        })
        .then(function(resp) {
          if (resp.data.code == '200') {
            var data = resp.data.data.project
            that.form = data
            var picList =
              data.photoPath && '' != data.photoPath
                ? data.photoPath.split(',')
                : []
            that.image1 = picList[0] ? base.httpCtx + picList[0] : that.image1
            that.image.img1 = picList[0] ? picList[0] : ''
            that.image2 = picList[1] ? base.httpCtx + picList[1] : that.image2
            that.image.img2 = picList[1] ? picList[1] : ''
            that.image3 = picList[2] ? base.httpCtx + picList[2] : that.image3
            that.image.img3 = picList[2] ? picList[2] : ''
            if (
              data.startDate &&
              data.startDate != '' &&
              data.endDate != '' &&
              data.endDate
            ) {
              that.form.allDay = util.myTime.getdayByDate(
                data.startDate,
                data.endDate
              )
            }
            that.setAreaFun(data && data.areaId)
            // if ("" != data.gpsPoint && undefined != data.gpsPoint) {
            //     var obj = data.gpsPoint.split(",");
            //     var point = { lng: obj[0], lat: obj[1] };
            //     that.center.lng = point.lng;
            //     that.center.lat = point.lat;
            //     that.setCenterMap(point);
            // }
          } else {
            that.$message.error(resp.data.msg)
          }
        })
    },
    //获取区域
    setAreaFun(id) {
      if ('' == id || undefined == id) return
      var that = this
      myHttp
        .getAreaById({
          id: id
        })
        .then(
          function(resp) {
            if (resp.data.code == '200') {
              var province = resp.data.data.area.provinceId
              var city = resp.data.data.area.cityId
              var area = resp.data.data.area.countyId
              if (resp.data.data.area.level == '3' && undefined == area) {
                area = resp.data.data.area.id
              }
              var arry = []
              arry.push(province)
              arry.push(city)
              arry.push(area)
              that.selectedOptions = arry
            }
          },
          function(error) {}
        )
    },
    //地图展示
    handler({ BMap, map }) {
      this.map = map
      this.geoc = new BMap.Geocoder()
      // this.getData();
      // this.map.enableScrollWheelZoom();   //启用滚轮放大缩小，默认禁用
      // this.map.enableContinuousZoom();    //启用地图惯性拖拽，默认禁用
      // if(!this.isPointShow&&this.isGetPont){
      //     var point = new BMap.Point(this.center.lng, this.center.lat)
      //     map.centerAndZoom(point, 12)
      //     var marker = new BMap.Marker(point) // 创建标注
      //     map.addOverlay(marker) // 将标注添加到地图中
      // }
      // var point = new BMap.Point(this.center.lng, this.center.lat)
      // map.centerAndZoom(point, 13)
      // var marker = new BMap.Marker(point) // 创建标注
      // map.addOverlay(marker) // 将标注添加到地图中
      // var circle = new BMap.Circle(point, 6, { strokeColor: 'Red', strokeWeight: 6, strokeOpacity: 1, Color: 'Red', fillColor: '#f03' })
      // map.addOverlay(circle)
    },
    //地图点击方法
    getClickInfo(e) {
      this.map.clearOverlays()
      var point = new BMap.Point(e.point.lng, e.point.lat)
      var marker = new BMap.Marker(point)
      this.map.addOverlay(marker)
      this.form.gpsPoint = e.point.lng + ',' + e.point.lat
      var that = this
      this.geoc.getLocation(e.point, function(rs) {
        var addComp = rs.addressComponents
        var address =
          addComp.province +
          addComp.city +
          addComp.district +
          addComp.street +
          addComp.streetNumber
          that.form.address = address
      })
    },
    //设置地图坐标和中点
    setCenterMap(obj) {
      var point = new BMap.Point(this.center.lng, this.center.lat)
      this.map.centerAndZoom(point, 12)
      var marker = new BMap.Marker(point)
      this.map.addOverlay(marker)
    },
    //保存当前项目
    saveProject() {
      console.log(this.selectedOptions)
      if (
        new Date(this.form.startDate).getTime() >
        new Date(this.form.endDate).getTime()
      ) {
        this.$message.error('计划开工日期不能大于竣工时间，请修改')
        return
      }
      if (this.form.name == '') {
        this.$message.error('请输入项目名称')
        return
      }
      var that = this
      this.form.userId = this.$store.state.user.id
      this.form.photoPath =
        this.image.img1 + ',' + this.image.img2 + ',' + this.image.img3
      this.form.areaId = this.selectedOptions[this.selectedOptions.length - 1]
      if (this.form.id == '' || this.form.id == '0') {
        myHttp.createProject(this.form).then(function(resp) {
          if (resp.data.code == '200') {
            that.$message.success('添加成功')
            that.$router.go(-1)
          } else {
            that.$message.error(resp.data.msg)
          }
        })
      } else {
        delete this.form.updateDate
        delete this.form.createDate
        delete this.form.teams
        myHttp.updateProject(this.form).then(function(resp) {
          if (resp.data.code == '200') {
            that.$message.success('修改成功')
            that.$router.go(-1)
          } else {
            that.$message.error(resp.data.msg)
          }
        })
      }
    },
    //跳转
    goMapAddr() {
      this.$router.push({ name: 'proPoint', params: { id: this.form.id } })
    },
    //监听时间
    dataFun(val) {
      if (
        this.form.startDate &&
        this.form.startDate != '' &&
        this.form.endDate != '' &&
        this.form.endDate
      ) {
        this.form.allDay = util.myTime.getdayByDate(
          this.form.startDate,
          this.form.endDate
        )
      }
    }
  }
}
</script>
<style scoped>
.content {
  height: 100%;
  padding: 10px;
  overflow: auto;
}
.proName-box {
  background: #fff;
  padding: 20px 60px;
}
.pro-box1,
.box-img,
.pro-box3,
.pro-box4 {
  display: flex;
  width: 100%;
}
.pro-box3,
.pro-box4 {
  flex-wrap: wrap;
}
.pro-box3 .item-con,
.pro-box4 .item-con {
  width: 100%;
  display: flex;
  margin-top: 15px;
}
.pro-box1 .item,
.item-con .item {
  width: 33%;
  display: flex;
  align-items: center;
}
.pro-box4 .item-con .item {
  width: 50%;
}
.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}
.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}
.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 100px;
  height: 100px;
  line-height: 100px;
  text-align: center;
  border: 1px dashed #ddd;
  margin: 0 30px;
}
.avatar {
  width: 100px;
  height: 100px;
  display: block;
}
.box-card {
  margin-bottom: 20px;
}
p {
  text-align: left;
  margin: 0;
  padding-left: 10px;
}
.required::before {
  content: '*';
  color: #f56c6c;
  margin-right: 4px;
}
.box-select .el-input {
  width: 100%;
}
</style>
<style>
.projectAdd .el-select,
.projectAdd .el-select > .el-input,
.projectAdd .el-select .el-input__inner {
  width: 240px;
}
</style>